'use client';
import { useMemo } from 'react';

// import { ProductCardFillStars } from '@/components/ui/icons';
// import { getProductReviewsV2 } from '@/services/product/reviews';
// import useSWR from 'swr';
// import { useLocale } from 'next-intl';
import NextLink from '@/components/next-link';
import { BRAND_CATEGORY_ID } from '@/constants';
import useCategoryStore from '@/store/category.store';
import { event_category_click } from '@/utils/gtm';

const ProductRatings = ({
  // entity_id,
  categories,
}) => {
  const menuTreeData = useCategoryStore((state) => state.menuTreeData);
  // const locale = useLocale();

  // const { data: productRating } = useSWR(
  //   `category-products-rating/${entity_id}/${locale}`,
  //   () => getProductReviewsV2(entity_id, locale),
  //   {
  //     revalidateOnFocus: false,
  //     revalidateOnMount: !!entity_id,
  //   }
  // );

  const filteredCategories = useMemo(() => {
    if (!Array.isArray(categories)) return [];

    return categories.filter((e) => {
      const validUrlKey = e?.url_key && e?.url_key !== 'default-category';
      const notBrandCategory =
        +e?.category_id !== BRAND_CATEGORY_ID &&
        +e?.parent_id !== BRAND_CATEGORY_ID;

      return validUrlKey && notBrandCategory;
    });
  }, [categories]);

  return (
    // <div className='flex items-center justify-between max-sm:flex-wrap max-sm:gap-2'>
    <div className='flex flex-wrap items-center gap-3'>
      {filteredCategories?.map((e) => (
        <NextLink
          key={e?.category_id}
          href={`/c/${e?.url_key}`}
          onClick={() =>
            event_category_click({
              menuTreeData,
              category: e,
              click_location: 'pdp_category_chip',
            })
          }
          className='flex max-h-8 min-h-8 cursor-pointer items-center justify-center rounded-full bg-blue-50 px-2 py-1 text-sm text-blue-800 lg:px-4'
        >
          {e?.name}
        </NextLink>
      ))}
    </div>
    //   <div className='flex items-center gap-1 lg:gap-2'>
    //   <ProductCardFillStars />
    //   <span className='text-tertiary-500 text-sm font-bold whitespace-nowrap lg:text-[15px]'>
    //     5 Reviews
    //   </span>
    // </div>
    // </div>
  );
};

export default ProductRatings;
